<template>
  <div :class="$style.base">
    <transition-group :name="reversed ? 'chevron' : 'chevron-reverse'">
      <div
        v-if="!reversed"
        key="chevron-down"
        :class="$style.chevron"
      >
        <BaseIcon
          name="chevron-down"
          :color="color"
        />
      </div>
      <div
        v-else
        key="chevron-up"
        :class="$style.chevron"
      >
        <BaseIcon
          name="chevron-up"
          :color="color"
        />
      </div>
    </transition-group>
  </div>
</template>

<script
  lang="ts"
  setup
>
withDefaults(
  defineProps<{
    color?: 'default' | 'inverted' | 'fixed' | 'inherit';
    reversed: boolean;
  }>(),
  {
    color: 'default',
  },
);
</script>

<style
  lang="scss"
  module
>
.base {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 2px;
  width: 20px;
  height: 20px;
  position: relative;
}

.chevron {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
</style>
